export const environment = {
  production: true,
  baseUrlRedirect: 'https://partners.ingood.es/',
  baseUrl: 'https://partners.ingood.es/api/',
  proxy: {
    enabled: true,
    root: 'https://appproxy.ingood.es',
    login: 'Account/login',
    api: 'helio-rsg'
  },
  dynatraceUrl: 'https://js-cdn.dynatrace.com/jstag/1658b155923/bf07634sen/8cb7de393ef4c9b2_complete.js',
  BD: 'xxx',
  // b2c: 'pre',
  ApiProducto: 'product',
  ApiPricing: 'pricing',
  ApiNotify: 'notify',
  ApiPerson: 'person',
  ApiPolicy: 'policies',
  ApiBilling: 'billing',
  ApiPayment: 'payment',
  ApiClaims: 'claims',
  // auth.config.ts configuration
  clientID: '358c4fe2-6e84-4766-974d-8dfabe88092e',
  authority: 'https://login.microsoftonline.com/75584e34-72c0-4772-b459-a9fe78fec27c',
  scopes: 'api://835f2f49-5732-49d2-af28-511edc1d4826/user_impersonation',
  endpointwebapi: 'api://835f2f49-5732-49d2-af28-511edc1d4826/user_impersonation',
  endpointgrahp: 'https://graph.microsoft.com/v1.0/me',
  scopewebapi: 'user_impersonation',
  redirectUri: 'https://partners.ingood.es/auth', // Points to window.location.origin by default. You must register this URI on Azure portal/App Registration.
  postLogoutRedirectUri: 'https://partners.ingood.es/',
  clientCapabilities: 'CP1', // This lets the resource server know that this client can handle claim challenges.
  endpoint: 'https://partners.ingood.es/',
  // end auth.config.ts configuration
  lang: 'es',
  langSource: 'web',
  // idIdioma: 1,
  // b2cDomain: 'devheliorma',
  logo: "ingoodByReale.svg",
  app_name: "Helio net",
  useValueCalendar: 'es-ES',
  environmentType: 'xxx',
  notify: {
    timeout: {
      seconds: 600
    }
  },
  //https://devblogs.microsoft.com/premier-developer/angular-how-to-add-application-insights-to-an-angular-spa/
  appInsights: {
    instrumentationKey: '9f301204-3857-4cbe-8594-6ab91ae23fc8'
  },
  helpContactInfo: {
    phone: 'xxx',
    whatsApp: 'xxx',
    email: 'ayuda@ingood.com'
  },
  ApimSubscriptionKey: '4dcc715979214661b2cd8a3d2ce81130'
};
